import { DevolutionsList } from "@/App/Devolutions/Table";

export function PageList() {
  return <DevolutionsList />;
}